import type { TOC } from '@ember/component/template-only'
import { BookLibraryResourcesLink } from 'teacher-ui-client/components/book-library/resources-link'

interface Signature {
  Element: HTMLDivElement
  Args: {
    showResourcesPill: boolean
    bookId: string
  }
}

export const BookLibraryBookCardFooter: TOC<Signature> = <template>
  <div data-test-book-card-footer class="relative {{if @showResourcesPill 'mb-3'}}" ...attributes>
    {{#if @showResourcesPill}}
      <BookLibraryResourcesLink class="absolute -top-5 right-0 shadow-md" @bookId={{@bookId}} />
    {{/if}}
  </div>
</template>

export default BookLibraryBookCardFooter
